import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AutoDirectService } from '../../services';
import {
  IAutoDirectLog,
  IAutoDirectResponse,
  IAutoDirectSummary,
  IAutoDirectSummaryFilter,
} from '../../interfaces/auto-direct-summary';
import { JobAlertService } from '../../services';
import { SelectItem } from 'primeng/api';
import { flatten } from '../../utils/flatten';
import { Table } from 'primeng';

@Component({
  selector: 'auto-direct-summary',
  styleUrls: ['./auto-direct-summary.component.scss'],
  templateUrl: 'auto-direct-summary.component.html',
})
export class AutoDirectSummaryComponent implements OnInit {
  @ViewChild('dataTable2') logTable: Table;

  jobList: IAutoDirectSummary[];
  logList: IAutoDirectLog[];
  selectedJob: IAutoDirectSummary;
  displayDialog = false;
  autoDirectLogList: any;
  selectedLog: any;
  runForm: UntypedFormGroup;
  running: boolean = false;
  loading: boolean = false;
  autoDirectSettingList: SelectItem[];
  errorMsg: any;
  globalFilter: any;
  state: IAutoDirectSummaryFilter = {};
  jobNumber: any;
  isLoading: boolean = true;
  jobCount: number = 0;

  constructor(
    private autoDirectService: AutoDirectService,
    private jobAlertService: JobAlertService,
    private fb: UntypedFormBuilder,
  ) {}

  async ngOnInit() {
    this.state.filters = {};
    this.search();
    this.initRunForm();
  }

  get previewForm() {
    return this.runForm.value;
  }

  initRunForm() {
    // Get list of settings
    this.runForm = this.fb.group({
      autoDirectSettingsId: [''],
      jobNumber: ['', Validators.required],
      preview: [true],
    });

    this.autoDirectService.getSettings().then((x) => {
      var defaultAutoDirectSettingsId = '';

      this.autoDirectSettingList = x
        .map((x) => {
          return { label: x.settingName, value: x.id };
        })
        .sort();

      if (this.autoDirectSettingList.length > 0) {
        this.runForm.patchValue({ autoDirectSettingsId: this.autoDirectSettingList[0].value });
      }
    });
  }

  onGridLazyLoad(event: any) {
    this.state.first = event.first;
    this.state.rows = event.rows;
    this.state.sortField = event.sortField;
    this.state.sortOrder = event.sortOrder;

    this.search();
  }

  search() {
    this.state.filters.jobNumber = { value: this.jobNumber };

    this.autoDirectService.getSummary(flatten(this.state)).then((result) => {
      this.jobList = result.items;
      this.jobCount = result.count;
      this.isLoading = false;
    });
  }

  runAutoDirect() {
    let f = this.runForm.value;
    this.running = true;
    this.errorMsg = '';

    this.jobAlertService
      .runAutoDirect(f.jobNumber, f.autoDirectSettingsId, f.preview)
      .then((x: IAutoDirectResponse) => {
        this.running = false;
        this.search();

        if (x.success == false) {
          this.errorMsg = x.comment;
        }
      });
  }

  viewHistory(id) {
    this.displayDialog = true;
    this.globalFilter = '';

    this.autoDirectService.getLogs(id).then((result) => {
      this.logList = [];
      this.logTable.reset();

      result.forEach((x) => {
        let codeArray = x.matchStatusName.split(/(?=[A-Z])/);
        x.matchStatusDesc = codeArray.join(' ');
      });
      this.logList = result;

      // Set page to #1
    });
  }
}
